import {t, useLanguage} from '../i18n';
import React from 'react';
import MarketplaceSearch from './MarketplaceSearch';
import '../styles/homeDiscovery.css';

export default function HomeDiscoveryHero({ image, query, onQueryChange, onSearch }) {
 useLanguage();
  return (
    <section className="home-discovery" aria-labelledby="home-discovery-title">
      <div className="home-discovery-banner" style={{ backgroundImage: `linear-gradient(90deg, rgba(0,49,43,.88), rgba(0,49,43,.38)), url(${image})` }}>
        <h1 id="home-discovery-title">{t("Encuentra tu servicio.")}<br />{t("Reserva tu momento.")}</h1>
        <p>{t("Belleza, bienestar, eventos y más, cerca de ti.")}</p>
      </div>
      <MarketplaceSearch value={query} onChange={onQueryChange} onSearch={onSearch} />
    </section>
  );
}
